import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/GridLegacy';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import { ReactElement } from 'react';
import { getLanguage } from 'react-multi-lang';
import './statistic-card.scss'
import { large_number_clipper } from '../../services/large_number_clipper';
import { Tooltip } from '@mui/material';
interface iProps {
  cardIcon: ReactElement;
  cardTitle: string;
  cardBody: string;
  avatarColor:string
}

export default function StatisticCard({
  cardBody,
  cardIcon,
  cardTitle,
  avatarColor
}: iProps) {

  let {clipped_num,raw_num, trigger_tooltip} =  large_number_clipper (cardBody)
               
  return (
      <Tooltip
      title={raw_num}
      
      >
    <Card sx={{ width:'100%'}} className='statistic-card'>

      <CardContent  sx={{
        paddingBottom:{sm:'24px',xs:'10px'},
        '&:last-child': {
      paddingBottom: { sm: '24px', xs: '10px' },
    },
        }} >
        <Box
          sx={{ display: 'flex', justifyContent: 'space-between' 
            , flexDirection:{lg:'row',xs:'column'} ,padding: {lg:'1.7rem',xs:'0.2rem'}
            
          }}
          >
              <Box>
            <Avatar sx={
            {backgroundColor:avatarColor,marginX:{lg:'0.1rem',xs:'0'}
           
            }} >
                {cardIcon}
                </Avatar>
          </Box>
          <Box sx={{display:'flex'
            ,flexDirection:'column',justifyContent:getLanguage()==='en'?"flex-end":'flex-start'
            ,overflow:'hidden'}}>
        
            <Typography variant='subtitle1' sx={{
              fontSize:{lg:'1.5vw',xs:'1rem'},
              textAlign:{lg:'end',xs:'center'}
            }}
     
            color={avatarColor} >
                {cardTitle}
            </Typography>
            <Typography  marginY={1} 
            sx={{
              fontSize:{lg:'1.4vw',sm:'1.1rem',xs:'0.5rem'}
              , textAlign:{lg:'end',xs:'center'},
              whiteSpace:'nowrap',
       
            }}
            >
                {
                 
                  clipped_num

             
                }
            </Typography>
          </Box>
          
        </Box>
      </CardContent>
    </Card>
      </Tooltip>
  );
}
